import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/dev-icons/linkedin.png'
import _imports_1 from '@/assets/icons/dev-icons/git.svg'


const _withScopeId = n => (_pushScopeId("data-v-810e6b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get in touch:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.linkedin.com/in/zachsmith258/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    draggable: "false",
    alt: "Zach Smith LinkedIn link"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/ZekeHD",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    draggable: "false",
    alt: "Zach Smith Github link"
  })
], -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_5))
}